import React from 'react'
import { LayoutCompanies } from './layout/LayoutCompanies'

export const CompaniesScreen = () => {
    return (
        <LayoutCompanies />
    )
}
